import type {ReactNode} from "react";
import type {DefaultTFuncReturn} from "i18next";

export enum ThemeColorType {
    yellow = 'yellow',
    green = 'green',
    blue = 'blue',
    pink = 'pink',
}

export interface IconItemType {
    icon?: ReactNode,
    iconBgColor?: ThemeColorType,
    title?: string | DefaultTFuncReturn,
    description?: string | ReactNode,
    footer?: ReactNode,
}

export enum InputType {
    Text = 'text',
    Password = 'password',
    Number = 'number',
    Time = 'time',
    Color = 'color',
    Email = 'email',
    Url = 'url',
    File = 'file',
    Phone = 'tel',
}

export interface MailAttachmentType {
    ContentType: string;
    Filename: string;
    Base64Content: string;
}

export interface FileInputContent {
    file: File;
    path: string;
}

export interface MailBodyType {
    subject: string;
    content: string;
    attachments: MailAttachmentType[] | null;
}

export interface FileAttachmentType {
    path: string,
    name: string,
    content: string,
}

export interface JoinFormValues {
    name: string,
    email: string,
    message: string,
}

export interface ProjectsPotRegisterFormValues {
    name: string,
    email: string,
    assoName: string,
    website: string,
    assoDesc: string,
    potGoal: string,
    acceptedRules: boolean,
}

export interface ProjectVoteRanking {
    choice: string,
    nbVotes: number,
    rank: number,
}